export default __webpack_public_path__ + "static/media/trivago_og.feab509c.jpg";